import {
  FILTER_STORAGE_KEY_STAFF,
  FILTER_STORAGE_KEY_OFFICE,
} from "../index";

/**
 * Get the appropriate storage key based on active tab
 * @param {string} activeTab - "1" for staff, "2" for office
 * @returns {string} Storage key
 */
const getStorageKey = (activeTab) => {
  return activeTab === "1" ? FILTER_STORAGE_KEY_STAFF : FILTER_STORAGE_KEY_OFFICE;
};

/**
 * Load filters from localStorage
 * @param {string} activeTab - "1" for staff, "2" for office
 * @returns {Object|null} Parsed filter object or null if not found/invalid
 */
export const loadFiltersFromStorage = (activeTab) => {
  try {
    const storageKey = getStorageKey(activeTab);
    const savedFilters = localStorage.getItem(storageKey);
    if (savedFilters) {
      return JSON.parse(savedFilters);
    }
  } catch (error) {
    console.error("Error loading filters from localStorage:", error);
  }
  return null;
};

/**
 * Save filters to localStorage
 * @param {Object} filters - Filter object to save
 * @param {string} activeTab - "1" for staff, "2" for office
 */
export const saveFiltersToStorage = (filters, activeTab) => {
  try {
    const storageKey = getStorageKey(activeTab);
    localStorage.setItem(storageKey, JSON.stringify(filters));
  } catch (error) {
    console.error("Error saving filters to localStorage:", error);
  }
};

/**
 * Clear filters from localStorage
 * @param {string} activeTab - "1" for staff, "2" for office
 */
export const clearFiltersFromStorage = (activeTab) => {
  try {
    const storageKey = getStorageKey(activeTab);
    localStorage.removeItem(storageKey);
  } catch (error) {
    console.error("Error clearing filters from localStorage:", error);
  }
};
